<script>
import AppSidebar from './AppSidebar.vue';
import AppConfig from './AppConfig.vue';

export default {
    components: {
        AppSidebar,
        AppConfig,
    },
    data() {
        return {
            contentFull: JSON.parse(localStorage.getItem('showSidebar')),
        };
    },
    methods: {
        toggleSettings() {
            this.$store.commit('toggleSettingsShow', true);
        },
        toggleMenu() {
            this.$refs.sidebar.toggle();
            this.contentFull = !this.contentFull;
        },
    },
};
</script>

<template>
    <div class="min-h-screen bg-[#fff]">
        <AppSidebar ref="sidebar" />
        <div
            class="p-0 transition-all relative"
            :class="{ 'ml-[280px]': contentFull }"
        >
            <div
                :class="{
                    'bottom-2 left-2': !contentFull,
                }"
                class="flex w-[40px] h-[40px] bg-gray-500 rounded-lg transition-all fixed bottom-4 left-4 z-50 shadow-md overflow-hidden delay-300">
                <button
                    @click="toggleSettings()"
                    type="button"
                    class="relative transition-all w-full h-full text-xs text-white flex justify-center items-center hover:bg-indigo-500">
                    <svg
                        :class="{ 'animate-spin': $store.getters.getSettingsShow }"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                        class="h-5 w-5 text-blue-gray-500">
                        <path
                            fill-rule="evenodd"
                            d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 00-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 00-2.282.819l-.922 1.597a1.875 1.875 0 00.432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 000 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 00-.432 2.385l.922 1.597a1.875 1.875 0 002.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 002.28-.819l.923-1.597a1.875 1.875 0 00-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 000-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 00-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 00-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 00-1.85-1.567h-1.843zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
                            clip-rule="evenodd"></path>
                    </svg>
                </button>
                <AppConfig
                    :show="$store.getters.getSettingsShow"
                    @close="$store.commit('toggleSettingsShow', false)"
                    @toggleMenu="toggleMenu()" />
            </div>

            <div
                class="fixed bg-white top-0 right-0 flex w-full items-center h-[58px] shadow-sm z-[49] pr-2 py-2 border-b-2 transition-all"
                :class="{
                    'pl-[288px]': contentFull,
                    'pl-2': !contentFull
                }"
            >
                <button type="button" @click="toggleMenu" class="w-[35px] h-[35px] flex justify-center items-center rounded-md hover:bg-gray-300 transition-all">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
                    </svg>
                </button>

                <div class="flex w-full h-full items-center justify-end gap-2" id="headerComponent"/>
            </div>
            <div class="flex w-full h-[58px]"/>

            <router-view />
        </div>
    </div>
</template>
